import { render, staticRenderFns } from "./RegimeTributario.vue?vue&type=template&id=b6a829cc&scoped=true&"
import script from "./RegimeTributario.vue?vue&type=script&lang=js&"
export * from "./RegimeTributario.vue?vue&type=script&lang=js&"
import style0 from "./RegimeTributario.vue?vue&type=style&index=0&id=b6a829cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a829cc",
  null
  
)

export default component.exports